
const SCALE_RELATIVE_TO_DIAGONAL = false

export const rand = (min, max) => {
  return Math.floor(Math.random() * (max + 1 - min) + min)
}


export const getDiagonal = () => {
  return Math.sqrt(Math.pow(window.innerWidth, 2) + Math.pow(window.innerHeight, 2))
}
export const absPositionX = (a) => {
  return a * window.innerWidth
}
export const absPositionY = (a) => {
  return a * window.innerHeight
}
export const relPositionX = (a) => {
  return a / window.innerWidth
}
export const relPositionY = (a) => {
  return a / window.innerHeight
}
export const posToPx = (a) => {
  return Math.round(a * window.innerWidth)
}

export const scaleToPx = (d) => {
  const baseW = SCALE_RELATIVE_TO_DIAGONAL ? getDiagonal() : window.innerWidth
  return Math.round(d * baseW)
} 